import React from 'react';
import { Link } from 'react-router-dom';
import { maskDayOfWeekUnlimited } from '../../masks';
import SVGWarningBang from '../../svg/WarningBang';

class ActionItems extends React.Component {
  state = {
    activeTab: 'menu'
  };

  render() {
    return (
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Action Items</h3>
          </div>
          <div className="cms__bar-right"></div>
        </div>
        <div className="cms__section-body cms__section-body--no-pad">
          <div className="tabs tabs--flex">
            <div
              className={this.getTabClasses('menu')}
              onClick={() => this.handleTabClick('menu')}
            >
              Menu
            </div>
            <div
              className={this.getTabClasses('email-chef')}
              onClick={() => this.handleTabClick('email-chef')}
            >
              Email Chef
            </div>
            <div
              className={this.getTabClasses('email-client')}
              onClick={() => this.handleTabClick('email-client')}
            >
              Email Client
            </div>
            <div
              className={this.getTabClasses('chefs')}
              onClick={() => this.handleTabClick('chefs')}
            >
              Chefs
            </div>
          </div>

          {this.isActiveTab('menu') && (
            <ActionItemsList
              actionItems={this.props.actionItems.needs_menu_selections}
              Component={ActionLinkMenu}
            />
          )}

          {this.isActiveTab('email-chef') && (
            <ActionItemsList
              actionItems={this.props.actionItems.needs_email_to_chef}
              Component={ActionLinkEmailChef}
            />
          )}

          {this.isActiveTab('email-client') && (
            <ActionItemsList
              actionItems={this.props.actionItems.needs_email_to_client}
              Component={ActionLinkEmailClient}
            />
          )}

          {this.isActiveTab('chefs') && (
            <ActionItemsList
              actionItems={this.props.actionItems.needs_chef}
              Component={ActionLinkChef}
            />
          )}
        </div>
      </div>
    );
  }

  getTabClasses = tab => {
    const classes = ['tab', 'tab--flex'];
    if (this.isActiveTab(tab)) classes.push('active');
    return classes.join(' ');
  };

  handleTabClick = activeTab => this.setState({ activeTab });

  isActiveTab = activeTab => activeTab === this.state.activeTab;
}
export default ActionItems;

const warningBang = (
  <span className="warning-bang">
    <SVGWarningBang />
  </span>
);

const ActionItemsList = ({ actionItems = {}, Component }) => {
  const dates = Object.keys(actionItems);
  return (
    <div className="action-items">
      {dates.map((day, i) => (
        <DayGroup
          key={i}
          day={day}
          actionItems={actionItems[day]}
          Component={Component}
        />
      ))}
    </div>
  );
};

const DayGroup = ({ day, actionItems = {}, Component }) => {
  return (
    <div className="day-group">
      <p className="p p--bold">{maskDayOfWeekUnlimited(day)}</p>
      {actionItems.map((item, i) => (
        <Component key={i} item={item} />
      ))}
    </div>
  );
};

const ActionLinkMenu = ({ item }) => {
  return (
    <Link to={`/admin/service/${item.id}`} className="action-item">
      {warningBang} Select dishes for {item.name}.
    </Link>
  );
};

const ActionLinkChef = ({ item }) => {
  return (
    <Link to={`/admin/service/${item.id}`} className="action-item">
      {warningBang} Select a chef for {item.name}.
    </Link>
  );
};

const ActionLinkEmailChef = ({ item }) => {
  return (
    <Link to={`/admin/service/${item.id}`} className="action-item">
      {warningBang} Send chef email for {item.name}.
    </Link>
  );
};

const ActionLinkEmailClient = ({ item }) => {
  return (
    <Link to={`/admin/service/${item.id}`} className="action-item">
      {warningBang} Send client email for {item.name}.
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/components/dashboard/ActionItems.js